var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.template === "cr_escalate"
        ? _c(
            "v-card",
            {
              staticClass: "app-card"
            },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "d-block text-left"
                },
                [
                  _c(
                    "h3",
                    {
                      staticClass: "pb-2"
                    },
                    [_vm._v(_vm._s(_vm.cr_escalate.resultmsg))]
                  )
                ]
              ),
              _c(
                "v-card-text",
                {
                  staticClass: "black--text"
                },
                [
                  _c("p", [
                    _c("strong", [_vm._v("Confirmation Number:")]),
                    _vm._v(" #" + _vm._s(_vm.cr_escalate.cr_id))
                  ]),
                  _c("p", [
                    _c("strong", [_vm._v("Accepted Offer:")]),
                    _vm._v(" " + _vm._s(_vm.cr_escalate.offer_name))
                  ]),
                  _c("br"),
                  _c("h4", [_vm._v("What's Next?")]),
                  _c("p", [_vm._v(_vm._s(_vm.cr_escalate.offer_message))]),
                  _c("p", [
                    _vm._v(
                      "Email notifications are sent as your request is updated."
                    )
                  ])
                ]
              ),
              _c(
                "v-card-actions",
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        color: "primary",
                        tile: "",
                        elevation: "0",
                        to: "/cancellations/".concat(_vm.cr_escalate.cr_id)
                      }
                    },
                    [_vm._v(" View Request ")]
                  ),
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        tile: "",
                        elevation: "0",
                        color: "gray"
                      },
                      on: {
                        click: _vm.redirectToDashboard
                      }
                    },
                    [_vm._v("Return to Dashboard")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.template === "cr_open"
        ? _c(
            "v-card",
            {
              staticClass: "text-left"
            },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "d-block"
                },
                [_c("h3", [_vm._v("Cancellation Request Received")])]
              ),
              _c(
                "v-card-text",
                {
                  staticClass: "black--text"
                },
                [
                  _c("p", [
                    _vm._v(
                      "Your cancellation request has been received and is pending processing. Please save your confirmation number for your records."
                    )
                  ]),
                  _c("p", [
                    _c("strong", [_vm._v("Confirmation Number:")]),
                    _vm._v(" #" + _vm._s(_vm.cr_open.id))
                  ]),
                  _c("p", [
                    _c("strong", [
                      _vm._v(
                        "You can re-enable auto-renewal any time before " +
                          _vm._s(
                            _vm.formatRenewalDate(
                              _vm.parseRenewalDate(_vm.cr_open.abort_by)
                            )
                          ) +
                          "."
                      )
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      "Email notifications are sent as your request is updated. "
                    )
                  ]),
                  _c("p", [_vm._v("Thank you for your patience.")]),
                  _c("p", [
                    _vm._v("Did you make a mistake or change your mind? "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#"
                        },
                        on: {
                          click: _vm.autorenewConfirmModalOpen
                        }
                      },
                      [_vm._v("Click here to enable auto-renewal.")]
                    )
                  ]),
                  _vm.autorenewConfirmModal
                    ? _c("autorenew-enable", {
                        attrs: {
                          "cr-id": _vm.cr_open.id,
                          "go-to-route": "/cancellations/".concat(
                            _vm.cr_open.id
                          )
                        },
                        on: {
                          close: _vm.autorenewCloseModal
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        secondary: ""
                      },
                      on: {
                        click: _vm.redirectToDashboard
                      }
                    },
                    [_vm._v("Return to Dashboard")]
                  ),
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        to: "/cancellations/".concat(_vm.cr_open.id)
                      }
                    },
                    [_vm._v(" View Request ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }